import PropTypes from 'prop-types';
import React from 'react';

import Sizes from 'brastrap/promotional/sizes/Sizes';
import Field from 'brastrap/common/field/Field.jsx';
import { filterSelectProps } from 'brastrap/common/field-select/FieldSelect';

const STYLE_PREFIX = 'c-field-size';

/**
 * @param {Array} modifiers
 * @returns {String}
 */
const getClassName = modifiers =>
  `${STYLE_PREFIX} ${modifiers.map(m => `${STYLE_PREFIX}--${m}`).join(' ')}`;

const isFieldSizes = true;

const FieldSizes = props => {
  const sizeProps = {
    ...filterSelectProps(props),
    className: getClassName(props.modifiers),
    isFieldSizes,
  };

  const sizes = (
    <Sizes
      {...sizeProps}
      modifiers={props.modifiers}
      useSingleDropdown={props.useSingleDropdown}
    />
  );

  if (props.label) {
    return (
      <Field {...props}>
        {(props.touched || !props.invalid) && props.note && (
          <em className="c-field__note">{props.note}</em>
        )}
        {sizes}
      </Field>
    );
  }

  return sizes;
};

FieldSizes.propTypes = {
  label: PropTypes.string,
  modifiers: PropTypes.array,
  name: PropTypes.string,
  sizes: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  touched: PropTypes.bool,
  invalid: PropTypes.bool,
  note: PropTypes.string,
};

FieldSizes.defaultProps = {
  sizes: [],
  modifiers: [],
};

export default FieldSizes;
